/**
 * LPC-10831: Build a wire-format "yyyy-MM-ddT00:00:00" string from a JS Date's
 * LOCAL year/month/day (no `Z` suffix, no timezone offset).
 *
 * Why this exists:
 *   `Date.prototype.toISOString()` produces a UTC instant ("...T...Z"). When the user
 *   picks a local-midnight date in a non-UTC zone (e.g. IST), the UTC instant lands on
 *   the previous calendar day, and any consumer that converts the string back to a
 *   calendar date in a different zone shifts the day by one.
 *
 *   This helper freezes the wire string to the calendar day the user actually picked,
 *   regardless of the runtime timezone.
 *
 * The entitlement-service backend defaults a missing effectiveDate to today using
 * `DateTime.SpecifyKind(DateTime.Today, DateTimeKind.Unspecified)`, which Newtonsoft
 * serializes in the same "yyyy-MM-ddT00:00:00" shape — so client-picked and server-
 * defaulted dates land on the wire identically.
 *
 * @param date a JS Date interpreted in the user's local timezone
 * @returns a 19-character "YYYY-MM-DDT00:00:00" string (no Z, no offset)
 */
export const toEffectiveDateString = (date: Date): string => {
  const yyyy = date.getFullYear().toString().padStart(4, "0");
  const mm = (date.getMonth() + 1).toString().padStart(2, "0");
  const dd = date.getDate().toString().padStart(2, "0");

  return `${yyyy}-${mm}-${dd}T00:00:00`;
};
